var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPalm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M54 77.838c0-18.673-9.564-33.943-17.572-43.57l-.353-.394a10.913 10.913 0 016.452-3.756c7.075-1.224 14.648 4.399 14.773 4.482a3.112 3.112 0 003.755-4.959c-.394-.29-9.793-7.303-19.544-5.664a16.61 16.61 0 00-7.905 3.63c3.216-3.796 9.025-8.734 16.598-6.97a3.113 3.113 0 001.432-6.059c-8.88-2.074-15.769 2.075-20.27 6.37.642-4.959 2.696-11.474 8.734-15.208A3.112 3.112 0 0036.822.45C26.448 6.901 24.892 18.77 24.83 24.744A31.287 31.287 0 00.99 34.08a3.112 3.112 0 104.4 4.399 25.105 25.105 0 0117.676-7.573c-6.224 2.614-12.614 8.03-12.614 17.822a3.112 3.112 0 106.224 0c0-6.971 4.834-10.374 8.797-12.075-5.56 8.9-2.656 22.428-2.51 23.113a3.113 3.113 0 006.078-1.349c-.892-4.15-1.867-14.71 2.822-19.897 7.303 8.776 15.914 22.615 15.914 39.255H23.169a3.112 3.112 0 100 6.224h36.393a3.112 3.112 0 100-6.224L54 77.838z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalm);
export default __webpack_public_path__ + "static/media/palm.40e6d240.svg";
export { ForwardRef as ReactComponent };